export const isThemeValid = (theme) => {
    return ["default", "compact"].includes(theme);
};
